import React from 'react'
import Font from '@cred/react-font'
import styles from './styles.module.scss'

const Loading = () => (
  <div className={styles.wrapper}>
    <div className={styles.spinner}>
      <div />
      <div />
      <div />
      <div />
    </div>
    <Font>Loading...</Font>
  </div>
)

export { Loading }
export default Loading
